import React, { forwardRef, memo } from 'react';
import cn from '../../../utils/cn';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../tooltips/tooltip/Tooltip';

type TiptapToolbarButtonProps = {
  icon: React.ComponentType<React.ComponentPropsWithoutRef<'svg'>>;
  tooltip: string;
  isActive: boolean;
} & React.ComponentPropsWithoutRef<'button'>;

const TiptapToolbarButton = memo(
  forwardRef<HTMLButtonElement, TiptapToolbarButtonProps>(
    ({ icon, tooltip, isActive, className, children, ...props }, ref) => {
      const Icon = icon;

      return (
        <Tooltip>
          <TooltipTrigger
            ref={ref}
            type="button"
            className={cn(
              'bg-neutral-100 hover:bg-neutral-300',
              {
                'bg-neutral-300': isActive,
              },
              className,
            )}
            {...props}
          >
            {children ?? <Icon />}
          </TooltipTrigger>
          <TooltipContent className="w-fit rounded px-2.5 py-1 text-sm">
            {tooltip}
          </TooltipContent>
        </Tooltip>
      );
    },
  ),
);

TiptapToolbarButton.displayName = 'TiptapToolbarButton';

export default TiptapToolbarButton;
